export let ADD_INQUIRY_TYPE = 'ADD_INQUIRY_TYPE';
export let ADD_INQUIRY_TEXT = 'ADD_INQUIRY_TEXT';
export let ADD_CONTACT_INFO = 'ADD_CONTACT_INFO';
export let SET_TARGET_SYSTEMS = 'SET_TARGET_SYSTEMS';
export let ADD_RECAPTCHA_TOKEN = 'ADD_RECAPTCHA_TOKEN';

export let CHANGE_INQUIRY_CONSENT = 'CHANGE_INQUIRY_CONSENT';

export let CHANGE_LANG = 'CHANGE_LANG';
export let LOCALE_SET = 'LOCALE_SET';
export let RESET_STATE = 'RESET_STATE';

export const VERIFYING_PHONE_NUMBER = 'VERIFYING_PHONE_NUMBER';
export const VERIFY_PHONE_NUMBER_SUCCESS = 'VERIFY_PHONE_NUMBER_SUCCESS';
export const VERIFY_PHONE_NUMBER_ERROR = 'VERIFY_PHONE_NUMBER_ERROR';